// extracted by mini-css-extract-plugin
module.exports = {"subscriptionBadges":"styles_subscriptionBadges__Cz7RA","badge":"styles_badge__CASoM"};